import { createContext } from 'react';

interface MenuContextType {
  menu: boolean;
  setMenu: (value: boolean) => void;
}

export const MenuContext = createContext<MenuContextType>({
  menu: false,
  setMenu: () => {},
});
